// extracted by mini-css-extract-plugin
module.exports = {"_aenderbarBis":"AenderbarBis__aenderbarBis__3w2JQ","_aenderbarBis__icon":"AenderbarBis__aenderbarBis__icon__3wfOn"};